// zone.js must be loaded before Angular bootstraps for zone-based change
// detection (provideZoneChangeDetection) to work. Bundled from npm so the
// version matches package.json / Angular's peer dependency.
import 'zone.js';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import './styles.styl';
import '../node_modules/ngx-toastr/toastr.css';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
